import { SelectOption } from '@/components/selectValidate';
import React from 'react';
import { ObjectType } from '@/shared/entities/types';
import { getToken } from '@/utils/authentication';
import { Select } from 'vkit/lib/components';

export interface SelectBenefitProps {
  name: string;
  onChange: Function;
  value?: string;
  onBlur?: Function;
  errors?: ObjectType;
  small?: boolean;
  companyId?: string;
  disabled?: boolean;
  placeholder?: string;
}

const SelectBenefit: React.FC<SelectBenefitProps> = ({
  name,
  onChange,
  value,
  onBlur,
  errors,
  small,
  disabled,
  placeholder,
}) => {
  return (
    <Select
      clearable
      autoRequest
      label='Beneficio'
      placeholder={placeholder ? placeholder : ''}
      onBlur={(value) => !disabled && onBlur?.(name, value)}
      onChange={(value, selected: SelectOption) => !disabled && onChange?.(name, value, selected)}
      requestPageParam='page'
      requestResponseRootPath='data'
      requestResponseText='name'
      requestResponseValue='id'
      requestRouter='/benefits'
      requestSearchParam='q'
      requestUri={process.env.REACT_APP_API_NEGOTIATIONS_URL}
      requestHeaders={{ authorization: `Bearer ${getToken()}` }}
      searchable
      textHelper={!disabled ? errors?.[name] ?? '' : undefined}
      value={value || ''}
      small={small}
    />
  );
};

export default SelectBenefit;
